import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Ukrainian pluralization — picks the right form based on the count.
 *
 * Ukrainian has 3 plural forms (unlike English's 2):
 *   • singular   (1, 21, 31, …):     1 кампанія
 *   • few        (2-4, 22-24, …):    3 кампанії
 *   • many       (0, 5-20, 25-30…):  7 кампаній
 *
 * Usage: pluralUA(n, ['кампанія', 'кампанії', 'кампаній'])
 */
export function pluralUA(n, forms) {
  const abs = Math.abs(Math.trunc(n));
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
}